import { connect } from 'react-redux'
import { DOMAIN } from '../../constants/config';
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import SideBar from '../../components/affix/SideBar.jsx';
import Loader from '../../components/icon/Loader.jsx'
import LotteryBetRecord from './reports/popPage/LotteryBetRecord.jsx'
import LotteryReport from './reports/LotteryReport.jsx'
import TeamManeger from './reports/TeamManeger.jsx'
import SmallLoading from './../../components/overlay/SmallLoading.jsx'

class Report extends React.Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      child: {},
      current: {},
      modal: null,
      showLoading:false
    }
    $.importDatePrototype()
  }

  componentDidMount() {
    this.resetIframeUrl(this.props)
  }

  componentWillReceiveProps(nextProps){
    const type = this.props.match.params.type;
    const name = this.props.match.params.name;
    const childname = this.props.match.params.childname;

    const _type = nextProps.match.params.type;
    const _name = nextProps.match.params.name;
    const _childname = nextProps.match.params.childname;

    // 当第一次userMenus加载完成时
    if (!_.isEmpty(nextProps.__USER.toJS().menus) && _.isEmpty(this.props.__USER.toJS().menus)){
      this.resetIframeUrl(nextProps);
    }

    if (nextProps.__USER.toJS().menus && nextProps.__USER.toJS().menus.length > 0 && (type != _type || name != _name || childname != _childname)) {
      // 重设当前显示iframe 的URL
      this.resetIframeUrl(nextProps);
    };
  }

  componentWillUnmount(){
    if (this.iFrame) {
      this.iFrame.onload = null;
    }
  }

  componentDidUpdate(){
    this.iFrame = document.getElementById('reportFrame');
    if (this.iFrame) {
      this.iFrame.onload = function() {
        this.setState({
          showLoading:false
        })
        this.iFrame.height = this.iFrame.contentWindow.document.body.offsetHeight;
      }.bind(this);
    }
  }

  // 重设显示区域
  resetIframeUrl(props){
    if (!_.includes(window.location.href, '#/report')) {
      return;
    }
    const { type, name, childname } = props.match.params;
    const menus = props.__USER.toJS().menus;
    // 未加载完成
    if (_.isEmpty(menus)) {return;}

    const hashLocation = window.location.href.split('report/')[1];
    // 当前选中
    let current, display;

    _.each(menus, function(category){
      if (category.location ===hashLocation ) {
        current = category;
        return false;
      }
      _.each(category.menus, function(menu){
          if(!menu.children && menu.location == hashLocation){
            current = menu;
          }
          if(!menu.children && menu.url == hashLocation){
            current = menu;
          }
          if(menu.children){
            _.each(menu.children, function(child){
              if(child.location == hashLocation){
                current = menu;
              }
            })
          }
      })
    })
    // 个人报表
    if (current.type === 'personal') {
        display = current.component;
    }else{
      // 一级
      if (!current.children) {
        if ( current.id == 519680) {
          display = current.location
        }else {
          display = current.component || current.uri.slice(1) +'?number='+Math.random();
        }
      }
      // 二级
      if (current.children) {
        const child = _.find(current.children, {location: hashLocation});
        display = child.component || child.uri.slice(1) +'?number='+Math.random();
      }
    }
    this.setState({
      current: current,
      display: display
    })

  }

  // 点击菜单事件
  handleClick(menu){
    if(menu.type!="personal"){
      this.setState({
        showLoading:true
      })
    }
    //找出未被被 屏蔽
     let enableMenus = [] ;
     _.map(menu.menus,(item,index)=>{
       if(  item.disabled != true){
         enableMenus.push(item)
       }
     });
    //点击 一级菜单，跳转到 第一个二级菜单
    if(enableMenus.length >0){
      window.location.href = '#/report/' + (enableMenus[0].location||enableMenus[0].url);
      //点击导航重新请求一次 ifram
      if(document.getElementById('reportFrame')){
        document.getElementById('reportFrame').contentWindow.location.reload(true)
      }
      return ;
    }
    
    if (menu.uri || menu.component || menu.location) {
      window.location.href = '#/report/' + (menu.location||menu.url);
        //点击导航重新请求一次 ifram
      if(document.getElementById('reportFrame')){
        document.getElementById('reportFrame').contentWindow.location.reload(true)
      }
    }
  }

  render() {
    const { type, name, childname } = this.props.match.params;
    const __user = this.props.__USER.toJS();
    const { current, child, display, showLoading } = this.state;
    const hashLocation = window.location.href.split("report/")[1];
    let displayMenus = __user.menus;
    displayMenus = _.filter(__user.menus, (item) => item.name === "personal management");
    // if (__user.menus && __user.menus.length > 0) {
    //   if (type == 'help') {
    //     displayMenus = _.filter(__user.menus, (item) => item.type == 'help');
    //   }else{
    //     displayMenus = _.filter(__user.menus, (item) => item.type != 'help');
    //   }
    // }

    return (
      <div className="sc-background-01">
        <SideBar />
        <RichHeader />
        {!displayMenus ? (
          <div className="report-container">
            <Loader />
          </div>
        ) : (
          <div className="report-container clear">
            <div className="menus">
              <ul>
                {displayMenus &&
                  displayMenus.map((menu, index) => (
                    <li key={index}>
                      <a
                        className={menu.type + " " + (current.type == "personal" && menu.type == "personal" ? "active" : "")}
                        onClick={this.handleClick.bind(this, menu)}>
                        <i className={menu.type} />
                        <span>{menu.name}</span>
                      </a>
                      {menu.menus &&
                        _.filter(menu.menus, (item) => !item.disabled).map((childMenu, idx) =>
                          childMenu.location ? (
                            <a
                              key={idx}
                              className={
                                childMenu.location == this.state.current.location ? "active childrenMenu" : "childrenMenu"
                              }
                              onClick={this.handleClick.bind(this, childMenu)}>
                              {/*<i></i>*/}
                              <span>{childMenu.name}</span>
                            </a>
                          ) : (
                            <a
                              key={idx}
                              className={childMenu.url == this.state.current.url ? "active childrenMenu" : "childrenMenu"}
                              onClick={this.handleClick.bind(this, childMenu)}>
                              <i></i>
                              <span>{childMenu.name}</span>
                            </a>
                          )
                        )}
                    </li>
                  ))}
              </ul>
            </div>
            {_.isString(display) ? (
              <div className="contents">
                {/*<div className="title-warp">*/}
                <span className="title">{current.name}</span>
                <div className={current.children && current.children.length > 0 ? "sub-menu" : ""}>
                  {current.children && current.children.length > 0
                    ? current.children.map((item, index) => (
                        <span
                          onClick={this.handleClick.bind(this, item)}
                          key={index}
                          className={item.location == hashLocation ? "active" : ""}>
                          {item.name}
                        </span>
                      ))
                    : null}
                </div>
                {/*</div>*/}

                <iframe src={DOMAIN + display} id="reportFrame" />
                <SmallLoading display={showLoading} text="加载中..." />
              </div>
            ) : (
              <div>{display}</div>
            )}
          </div>
        )}
        <MainFooter />
      </div>
    );
  }
}

reactMixin(Report.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Report)